import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMoment from 'vue-moment'
import VueMeta from 'vue-meta'
import VueQrcodeReader from 'vue-qrcode-reader'

Vue.use(VueQrcodeReader)
// import io from 'socket.io-client'
// const socket = io(process.env.VUE_APP_BACKEND_SOCKET, {
// 	reconnection: true,
// 	transports: ['websocket'],
// })
// Vue.prototype.$socket = socket
// 뷰가드 설정
router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (sessionStorage.getItem('here-t') === null) {
			router.push({ name: 'reserveLogin', params: { code: to.params.code } }).catch(() => {})
		} else {
			next()
		}
	} else {
		next()
	}
})
Vue.use(VueMoment)
window.Kakao.init(process.env.VUE_APP_KAKAO_CODE)
Vue.use(VueMeta)
import VueMask from 'v-mask'
Vue.use(VueMask)
new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app')
